import { render, staticRenderFns } from "./PaymentsPage.vue?vue&type=template&id=0a50788a&scoped=true"
import script from "./PaymentsPage.vue?vue&type=script&lang=ts"
export * from "./PaymentsPage.vue?vue&type=script&lang=ts"
import style0 from "./PaymentsPage.vue?vue&type=style&index=0&id=0a50788a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a50788a",
  null
  
)

export default component.exports